export const renderMarkdown = (md = "") => {
  let html = md.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  html = html.replace(/^### (.*)$/gm, "<h3>$1</h3>");
  html = html.replace(/^## (.*)$/gm, "<h2>$1</h2>");
  html = html.replace(/^# (.*)$/gm, "<h2>$1</h2>");
  html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  html = html.replace(/\*(.+?)\*/g, "<em>$1</em>");
  html = html.replace(/`([^`]+)`/g, "<code>$1</code>");
  html = html.replace(
    /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
  );
  html = html.replace(
    /(^|[^"=>])(https?:\/\/[^\s<]+)/g,
    '$1<a href="$2" target="_blank" rel="noopener noreferrer">$2</a>'
  );
  const lines = html.split("\n");
  const out = [];
  let inUl = false, inOl = false;
  for (const ln of lines) {
    const ulMatch = /^\s*[-*]\s+(.*)$/.exec(ln);
    const olMatch = /^\s*\d+\.\s+(.*)$/.exec(ln);
    if (ulMatch) {
      if (!inUl) { out.push("<ul>"); inUl = true; }
      if (inOl) { out.push("</ol>"); inOl = false; }
      out.push(`<li>${ulMatch[1]}</li>`);
    } else if (olMatch) {
      if (!inOl) { out.push("<ol>"); inOl = true; }
      if (inUl) { out.push("</ul>"); inUl = false; }
      out.push(`<li>${olMatch[1]}</li>`);
    } else {
      if (inUl) { out.push("</ul>"); inUl = false; }
      if (inOl) { out.push("</ol>"); inOl = false; }
      if (ln.trim() === "") out.push("");
      else if (/^<h[23]>/.test(ln)) out.push(ln);
      else out.push(`<p>${ln}</p>`);
    }
  }
  if (inUl) out.push("</ul>");
  if (inOl) out.push("</ol>");
  return out.join("\n");
};
